__turbopack_context__.v({
  "root": "tweet-body-module__ZNRZja__root",
});
